<template>
  <Navbar v-if="$route.name !== 'PageNotFound'" />
  <main>
    <router-view />
  </main>
  <Footer v-if="$route.name !== 'PageNotFound'" />
</template>

<script setup lang="ts">
  import { onMounted } from "vue"
  import { useHead } from "@unhead/vue"
  import Navbar from "@/components/navigation/Navbar.vue"
  import Footer from "@/components/navigation/Footer.vue"
  import router from "./router"
  import { setMetaData } from "@/utils/functions"
  import { useApolloClient } from '@vue/apollo-composable'
  import 'animate.css'

  const { resolveClient } = useApolloClient()
  const ApolloClient = resolveClient()

  useHead({
    titleTemplate: (titleChunk) => {
      return titleFormat(titleChunk);
    },
    meta: [
      { name: "description", content: "We're Nologo Studios. We believe in developing and implementing clear strategies for how digital can grow your business and achieve your goals." }
    ],
    title: null, 
  })

  onMounted(() => {
    getMetaData(router.currentRoute.value.path)
  })

  router.afterEach((to, from) => {
  if (from.path !== to.path) {
    if (!to.path.startsWith('/services/')) {
        getMetaData(to.path)
    }
  }
})

  function getMetaData (path: string) {
    setMetaData(path == "/" ? "home" : path, ApolloClient)
  }

  function titleFormat (titleChunk: any) {
    const isServiceRoute = router.currentRoute.value.path.startsWith('/services/');

    if (isServiceRoute && !titleChunk) {
        return null;
    }

    if (titleChunk) {
        return titleChunk + " | Nologo Studios";
    }
    
    return "Nologo Studios";
  }
</script>

<style lang="scss">
  @import "~bootstrap/scss/bootstrap.scss";
</style>